import React, { useState, useRef, useEffect } from "react";
import "./DynamicBottomBar.css";
import { useMultiExpConfig } from "../context/MultiExpConfigProvider"; 

function DynamicBottomBar({ tabs = [], isFormOpen = false }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const touchStartRef = useRef({ x: 0, y: 0 });
  const touchMoveRef = useRef({ x: 0, y: 0 });
  const isSwipingRef = useRef(false);
  const containerRef = useRef(null);


  const { isModelViewerInteractive } = useMultiExpConfig();

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
 
      container.addEventListener('touchstart', handleTouchStart, { passive: false });
      container.addEventListener('touchmove', handleTouchMove, { passive: false });
      container.addEventListener('touchend', handleTouchEnd, { passive: false });


      return () => {
        container.removeEventListener('touchstart', handleTouchStart, { passive: false });
        container.removeEventListener('touchmove', handleTouchMove, { passive: false });
        container.removeEventListener('touchend', handleTouchEnd, { passive: false });
      };
    }
  }, [tabs.length, isModelViewerInteractive, isFormOpen]);

  if (tabs.length === 0) {
    return null;
  }

  if (tabs.length === 1) {
    return <div className="single-component">{tabs[0].component}</div>;
  }


  const handleTouchStart = (e) => {

    if (isFormOpen || isModelViewerInteractive) {
      return;
    }
 

    const touch = e.touches[0];
    touchStartRef.current = {
      x: touch.clientX,
      y: touch.clientY,
    };
    isSwipingRef.current = false;
  };

  const handleTouchMove = (e) => {
   
    if (isModelViewerInteractive || isFormOpen) {
      return;
    }

    const touch = e.touches[0];
    touchMoveRef.current = {
      x: touch.clientX,
      y: touch.clientY,
    };

    const dx = touchMoveRef.current.x - touchStartRef.current.x;
    const dy = touchMoveRef.current.y - touchStartRef.current.y;

    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
      isSwipingRef.current = true;
      e.preventDefault();
    } else {
        isSwipingRef.current = false;
    }
  };

  const handleTouchEnd = (e) => {
    
    if (isModelViewerInteractive || isFormOpen) {
      return;
    }

    if (!isSwipingRef.current) return;

    const touch = e.changedTouches[0];
    const dx = touch.clientX - touchStartRef.current.x;

    if (Math.abs(dx) > 50) {
      if (dx > 0) {
        setActiveIndex((prev) => (prev - 1 + tabs.length) % tabs.length);
      } else {
        setActiveIndex((prev) => (prev + 1) % tabs.length);
      }
    }
    isSwipingRef.current = false;
  };

  return (
    <div
      className="dynamic-container"
      ref={containerRef}
    >
      <div className="active-component">{tabs[activeIndex].component}</div>
    </div>
  );
}

export default DynamicBottomBar;